import React, { useState } from "react";
import "./AdminPage.css";
import { Flex, Statistic } from "antd";
import MenuNavbarAdmin from "../../Components/MenuNavbarAdmin/MenuNavbarAdmin";
import DashBoardAdmin from "../../Components/DashBoardAdmin/DashBoardAdmin";
import NewRestaurantAdmin from "../../Components/NewRestaurantAdmin/NewRestaurantAdmin";
import NewCaracteristicsAdmin from "../../Components/NewCaracteristicsAdmin/NewCaracteristicsAdmin";

export default function AdminPage() {

  return (
    <MenuNavbarAdmin />
  );
}
